<section [formGroup]="form">
    <div [hidden]="!isMediaRecordingEnabled">
        <mat-slide-toggle #toggle
                        [checked]="form.get('enabled')!.value"
                        class="process-slide-toggle"
                        formControlName="enabled">
            {{ 'screen_recording_enable' | translate }}
        </mat-slide-toggle>

        <div [hidden]="!form.get('enabled')!.value">
            <mat-form-field *ngFor="let control of controls">
                <input [formControlName]="control.name"
                    [max]="control.max"
                    [min]="control.min"
                    [placeholder]="control.placeholder | translate"
                    matInput
                    required
                    type="number"
                    uiRestrictInput="^[0-9]+$"
                    class="form-control" />
                <mat-error *ngIf="form.get(control.name)!.hasError('range')">
                    {{
                        'screen_recording_field_range_error' | translate: {
                            min: form.get(control.name)!.getError('range').min,
                            max: form.get(control.name)!.getError('range').max
                        }
                    }}
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <div [hidden]="!isAutoStartEnabled">
        <mat-slide-toggle #toggle
            [checked]="form.get('autoStartProcess')!.value"
            class="process-slide-toggle"
            formControlName="autoStartProcess">
            {{ 'processes_settings_auto_start' | translate }}
        </mat-slide-toggle>
    </div>
</section>
